import apiClient from './index'
import type { Supplier, SupplierCreate, SupplierUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/suppliers'

export const suppliersApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<Supplier[]>(BASE_URL, { params }).then(res => res.data),
  getById: (id: number) => apiClient.get<Supplier>(`${BASE_URL}/${id}`).then(res => res.data),
  create: (data: SupplierCreate) => apiClient.post<Supplier>(BASE_URL, data).then(res => res.data),
  update: (id: number, data: SupplierUpdate) => apiClient.put<Supplier>(`${BASE_URL}/${id}`, data).then(res => res.data),
  delete: (id: number) => apiClient.delete<Supplier>(`${BASE_URL}/${id}`).then(res => res.data),
}
